export default __webpack_public_path__ + "static/media/30.da16d984.png";